import { useContext } from 'react';

import Button from '@mui/material/Button';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import LandingDynamicWorkflow from './landingDynamicWorkflow';
import LandingKebabMenu from './LandingKebabMenu';
import LandingPlaceholder from './LandingPlaceholder';
import { LandingTableBodyProps } from './types';
import { AppContext } from '../App/appReducer';
import { AppActionKind, AppPageKind, BuildWorkflow } from '../App/types';

export default ({ loading, data }: LandingTableBodyProps) => {
  const { dispatch } = useContext(AppContext);

  const handleWorkflowClick = (workflowId: string) => {
    dispatch({
      type: AppActionKind.BUILD_WORKFLOW,
      payload: {
        workflowId: workflowId as string,
        page: AppPageKind.FORM_BUILDER
      } as BuildWorkflow
    });
  };

  const formateDateTime = (dateTime: Date) => {
    return dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString();
  };

  const getLivePausedDraftStatus = (workflow: LandingDynamicWorkflow) => {
    if (workflow.isPublished && workflow.isPaused) {
      return 'Paused';
    } else if (workflow.isPublished && !workflow.isPaused) {
      return 'Live';
    } else {
      return 'Draft';
    }
  };

  return (
    <TableBody>
      {loading && <LandingPlaceholder />}
      {!loading &&
        data.map((row) => (
          <TableRow key={row.id}>
            <TableCell>
              <Button
                variant="text"
                onClick={() => handleWorkflowClick(row.id)}
              >
                {row.name}
              </Button>
            </TableCell>
            <TableCell>{row.workflowType}</TableCell>
            <TableCell>
              {row.isPublished ? 'Published' : 'Unpublished'}
            </TableCell>
            <TableCell>{getLivePausedDraftStatus(row)}</TableCell>
            <TableCell>
              {row.lastUpdated
                ? formateDateTime(new Date(row.lastUpdated))
                : ''}
            </TableCell>
            <TableCell>{row.lastUpdatedBy || ''}</TableCell>
            <TableCell>
              {row.isPublished && <LandingKebabMenu workflowInfo={row} />}
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  );
};
